/*
 * jQuery offscreen plugin
 *
 * Copyright Cory LaViska for A Beautiful Site, LLC
 *
 * @license: http://opensource.org/licenses/MIT
 *
 */
(function($) {
  var $window = $(window);

  function getViewportWidth() {
    return window.innerWidth || $window.width();
  }

  function getViewportHeight() {
    return window.innerHeight || $window.height();
  }

  $.extend($.expr[':'], {
    'off-top': function(el) {
      return el.getBoundingClientRect().top < 0;
    },
    'off-right': function(el) {
      return el.getBoundingClientRect().right > getViewportWidth();
    },
    'off-bottom': function(el) {
      return el.getBoundingClientRect().bottom > getViewportHeight();
    },
    'off-left': function(el) {
      return el.getBoundingClientRect().left < 0;
    },
    'off-screen': function(el) {
      var rect = el.getBoundingClientRect();
      var vw = getViewportWidth();
      var vh = getViewportHeight();

      return rect.bottom < 0 || rect.top > vh || rect.right < 0 || rect.left > vw;
    }
  });
})(jQuery);
